import { Flex } from "antd";

import { PrimaryText } from "@/components/Typography/Styled";

export const TooltipTextComponent = () => {
    return (
        <Flex vertical gap={8}>
            <PrimaryText $textColor="white">
                Після підтвердження зміни:
            </PrimaryText>

            <PrimaryText $textColor="white">
                ТТ працюватимуть окремо, навіть на одній адресі.
            </PrimaryText>

            <PrimaryText $textColor="white">
                - архівна ТТ повністю виключається з маршрутів, всі її плани та
                прогрес виконання KPI будуть безповоротно видалені;
            </PrimaryText>

            <PrimaryText $textColor="white">
                - якщо одна ТТ стає батьківською до іншої, план, прогрес
                виконання KPI та дебіторська заборгованість будуть перенесені на
                нову ТТ;
            </PrimaryText>

            <PrimaryText $textColor="white">
                - якщо батьківська і дочірня ТТ належать до різних маршрутів,
                перенос плану може серйозно порушити баланс розподілу планів та
                вплинути на роботу торгової команди; - незалежні
            </PrimaryText>

            <PrimaryText fontWeight={"700"} $textColor="error">
                Цю дію неможливо скасувати!!!
            </PrimaryText>
        </Flex>
    );
};
